import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * @copyright Schweizerische Bundesbahnen SBB
 * @class WidgetNotifyService
 * @version 0.0.1
 * @since September 2017
 * @description The WidgetNotifyService provides subjects for widget handling
 * and can be used by components and services
 */
@Injectable({
  providedIn: 'root',
})
export class WidgetNotifyService {
  // Notify component wurde entfernt
  public onComponentDestroySubject: Subject<any>;
  public onListViewCreatedSubject: Subject<any>;
  public onShowFeatureSubject: Subject<any>;
  public onArbeitsbereichChangedSubject: Subject<any>;
  public onMapClickedSubject: Subject<boolean>;
  public onMainViewReadySubject: Subject<boolean>;

  constructor() {
    // Notify component wurde entfernt
    this.onComponentDestroySubject = new Subject();
    this.onListViewCreatedSubject = new Subject();
    this.onShowFeatureSubject = new Subject();
    this.onArbeitsbereichChangedSubject = new Subject();
    this.onMapClickedSubject = new Subject<boolean>();
    this.onMainViewReadySubject = new Subject<boolean>();
  }
}
